import React from "react";
import { Row } from "antd";

const CenteredRow = ({
  children,
  direction = "column",
  justify = "center",
  align = "middle"
}) => {
  return (
    <Row
      type="flex"
      justify={justify}
      align={align}
      style={{ padding: "3em 1em", flexDirection: direction, height: "100%" }}
    >
      {children}
    </Row>
  );
};

export default CenteredRow;
